/**
 * @generated SignedSource<<9bf3b467c4339db9009f9752c8557cd2>>
 * @relayHash 113b66fe53b02698654a159f858772ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 808561747853f51bf295dd617fbcb21649d2e0bc4eb7f67fe6baba0b910e3ff9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BoardCustomFilterRelayQuery } from './BoardCustomFilterRelayQuery.graphql';

const node: PreloadableConcreteRequest<BoardCustomFilterRelayQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "808561747853f51bf295dd617fbcb21649d2e0bc4eb7f67fe6baba0b910e3ff9",
    "metadata": {},
    "name": "BoardCustomFilterRelayQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
